<style>
  /* Add this style to your component or global CSS */
  #print-section table {
    border-collapse: collapse;
    width: 100%;
  }

  #print-section th,
  #print-section td {
    padding: 4px 6px;
    font-size: 12px;
    border: 1px solid #000;
    word-wrap: break-word;
    overflow: hidden;
    text-align: center;
  }

  #print-section th {
    font-weight: bold;
    background-color: #f2f2f2;
  }

  .text-right {
    text-align: right !important;
  }

  .text-left {
    text-align: left !important;
  }

  .no-wrap {
    white-space: nowrap;
  }
</style>

<div *ngIf="reportType == 'InDetail-personalledger1'">
  <div class="container-fluid" id="print-section" style="margin-top: 50px; padding: 0;">
    <table class="table table-bordered" style="width: 100%; margin: 0;">
      <thead>
        <tr>
          <th colspan="4" style="font-size: 18px;">हिंदुस्थान प्रकाशन संस्था - विवेक साप्ताहिक</th>
          <th colspan="4" style="font-size: 14px; text-align: center;">Advertiser Personal Ledger - In Details</th>
          <th colspan="3" style="font-size: 12px; text-align: center;">Date : From {{ startDate | date: 'dd-MM-yyyy' }}
            - To {{ endDate | date: 'dd-MM-yyyy' }}</th>
          <th colspan="2" style="font-size: 12px; text-align: right;">दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}</th>
        </tr>

        <tr>
          <th colspan="4"
            style="font-weight: bold; text-align: center; font-size: 16px; border-right: 4px solid black;">डेबिट</th>
          <th colspan="9" style="font-weight: bold; text-align: center; font-size: 16px;">क्रेडिट</th>
        </tr>

        <tr>
          <th style="width: 8%;font-size: 14px;" rowspan="2">Invoice<br>No</th>
          <th style="width: 7%; font-size: 14px;" rowspan="2">Invoice <br>Date</th>
          <th style="width: 10%;font-size: 14px;" rowspan="2">Issue<br>Name</th>
          <th style="width: 10%; border-right: 4px solid black;font-size: 14px;" rowspan="2">Invoice<br>Amount</th>
          <th style="width: 8%;font-size: 14px;" rowspan="2">Receipt<br>No</th>
          <th style="width: 8%;font-size: 14px;" rowspan="2">Receipt<br>Date</th>
          <th style="width: 8%;font-size: 14px;" rowspan="2">Credit<br>Voucher</th>
          <th style="width: 12%;font-size: 14px;" rowspan="2">Bank<br>Details</th>
          <th style="width: 8%;font-size: 14px;" rowspan="2">Invoice<br>Number</th>
          <th class="p-1 text-end" style="width: 8%;font-size: 14px;" rowspan="2">Receipt<br>Amt.</th>

          <!-- Cr.Note Amt. as parent -->
          <th class="p-1 text-end" style="font-size: 14px;" colspan="2">Cr.Note<br>Amt.</th>

          <th style="width: 10%;font-size: 14px;" rowspan="2">Balance</th>
        </tr>
        <tr>
          <!-- Sub-columns under Cr.Note Amt. -->
          <th class="p-1 text-end" style="width: 6%; font-size: 14px;">TDS</th>
          <th class="p-1 text-end" style="width: 6%; font-size: 14px;">Other</th>
        </tr>

      </thead>

      <tbody *ngFor="let data of getpersonalleddata; let i = index">
        <tr>
          <td colspan="13" style="font-size: 16px; text-align: left; font-weight: bold; padding: 10px;">
            Advertiser Name : <span class="no-wrap">{{data.advt_name}}</span>
          </td>
        </tr>

        <tr>
          <td colspan="3" style="font-weight: bold; font-size: 14px; text-align: left;">Opening Balance</td>
          <td colspan="10" style="text-align: right; font-weight: bold; font-size: 16px;">{{data.opening_bal}} येणे</td>
        </tr>

        <tr *ngFor="let data1 of data.rep_data">
          <td class="no-wrap" style="font-size: 14px;font-weight: bold;">{{ data1.invoice_no }}</td>
          <td class="no-wrap" style="font-size: 14px;font-weight: bold;">{{ data1.invoice_date }}</td>
          <td class="no-wrap" style="font-size: 14px;font-weight: bold;">{{ data1.issue_name }}</td>
          <td class="text-right no-wrap" style="border-right: 4px solid black; font-weight: bold; font-size: 14px;">
            {{ data1?.net_amt ? (data1.net_amt * 1).toFixed(2) : '' }}
          </td>
          <td class="no-wrap" style="font-size: 14px;font-weight: bold;">{{ data1.credit_voc }} {{ data1.rcpt_no}}</td>
          <td class="no-wrap" style="font-size: 14px;font-weight: bold;">{{ data1.rcpt_date }} {{ data1.voc_date }}</td>
          <td class="no-wrap" style="font-size: 14px;font-weight: bold;">{{ data1.voucher_no }}</td>
          <td class="no-wrap" style="font-size: 14px;font-weight: bold;">
            <ng-container *ngIf="data1.cheque_no || data1.pymt_options">
              C.No: {{ data1.cheque_no }} P.M: {{ data1.pymt_options }}
            </ng-container>
          </td>
          <td class="no-wrap" style="font-size: 14px;font-weight: bold;">{{ data1.invoice_num }}</td>
          <td class="text-right no-wrap" style="font-size: 14px;font-weight: bold;">{{ data1.rcv_amt != 0 ?
            (data1.rcv_amt * 1).toFixed(2) : '' }}</td>
          <td class="text-right" style="font-weight: bold; font-size: 14px;">
            {{ (data1?.tds_amt && data1.tds_amt !== '') ? (data1.tds_amt * 1).toFixed(2) : '' }}
          </td>

          <td class="text-right" style="font-weight: bold; font-size: 14px;">
           
            {{ (data1?.other_credit_amt && data1.other_credit_amt !== '') ? (data1.other_credit_amt * 1).toFixed(2) : '' }}
          </td>

          <td class="text-right no-wrap" style="font-size: 14px;font-weight: bold;">
            <ng-container *ngIf="data1.bal_amt!=null">{{ (data1.act_amt * 1).toFixed(2) }} येणे</ng-container>
          </td>
        </tr>


        <tr>
          <td colspan="3" class="text-right" style="font-weight: bold; font-size: 15px;">Invoice Total</td>
          <td class="text-right" style="font-weight: bold; font-size: 15px; border-right: 4px solid black;">
            {{(data.invoice_total* 1).toFixed(2)}}</td>
          <td colspan="5"></td>
          <td class="text-right" style="font-weight: bold; font-size: 15px;">{{(data.total_rcpt_amt* 1).toFixed(2)}}
          </td>
          <td class="text-right" style="font-weight: bold;font-size: 15px;">{{ (TotalcreditTDSAmt * 1).toFixed(2) }}
          </td>
          <td class="text-right" style="font-weight: bold;font-size: 15px;">{{ (TotalCreditOtherTotal * 1).toFixed(2) }}
          </td>
          <td></td>
        </tr>

        <tr>
          <td colspan="3" class="text-right" style="font-weight: bold; font-size: 15px;">Total</td>
          <td class="text-right" style="font-weight: bold; font-size: 15px; border-right: 4px solid black;">
            {{(data.invoice_total1* 1).toFixed(2)}}</td>
          <td colspan="6" style="font-weight: bold; font-size: 15px;"></td>
          <td colspan="2" class="text-right" style="font-weight: bold; font-size: 15px;">{{(data.all_total_amount * 
            1).toFixed(2)}}</td>
          <td colspan="1" class="text-right" style="font-weight: bold; font-size: 15px;">{{(balancecfamt *
            1).toFixed(2)}}</td>
        </tr>

        <tr>
          <td colspan="3" style="font-weight: bold; font-size: 15px;">Balance C/F</td>
          <td class="text-right" style="font-weight: bold; font-size: 16px; border-right: 4px solid black;">
            {{(balancecfamt * 1).toFixed(2)}}</td>
          <td style="font-weight: bold; font-size: 15px;">येणे</td>
          <td colspan="8" style="font-weight: bold; font-size: 15px;"></td>
        </tr>
      </tbody>
    </table>
  </div>

  <div style="margin-left: 70%; margin-bottom: 2%;" class="noPrint">
    <button class="noPrint"
      style="margin-top: 2%; margin-right: 10px; padding: 8px 15px; border: 1px solid #000; background: white; color: #000;"
      (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">
      Export
    </button>

    <button class="noPrint"
      style="margin-top: 2%; margin-left: 2%; padding: 8px 15px; border: 1px solid #000; color: #000;" mat-raised-button
      color="primary" (click)="printPageA4Landscape()">
      Print
    </button>

    <button class="noPrint" style="margin-top: 2%; padding: 8px 15px; border: 1px solid #000; color: #000;" mat-button
      mat-dialog-close>
      Close
    </button>
  </div>
</div>